


export const API_URL = "https://www.worldcubeassociation.org/api/v0";
export const API_COMP_URL = "https://www.worldcubeassociation.org/api/v0/competitions/";
export const CALENDAR_EVENTS_URL = "/calendar_events.json";
export const wcaProfileUrl = id => `https://www.worldcubeassociation.org/persons/${id}`;
